import convertImageToBase64 from '../../utils/converitr-imagen-base64';

export const formularioCategoriaOrdenSlice = (set,get) => ({
    obtenerCategoriaOrden: () => {
        fetch("/p_categoria_orden")
        .then((res) => res.json())
        .then(async(data) => {
            console.log('la datas',data);
            if(data.status === 1){
                set({ sucursalesOrden: [{ value: data.data[0][0].ID_SUC, label: data.data[0][0].NOMBRE_SUCURSAL_SUC }] })
                set({ sucursales: data.data[0].map((item) => { return { value: item.ID_SUC, label: item.NOMBRE_SUCURSAL_SUC } }) })
                set({ categoriasOrden: data.data[1], categoriasOrdenTemp: data.data[1] })
            }
            set({isLoading:false});
        });
    },
    handleSave: () => {
        let elOrden = get().categoriasOrdenTemp.filter(categoria => categoria.ID_SUC == get().sucursalesOrden[0].value).map((item,index) => {
            return {
                cp: item.ID_CP,
                suc: item.ID_SUC,
                orden: index + 1,
            }
        })
        console.log('el orden',elOrden);
        
        fetch("/p_categoria_orden",{
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                orden: elOrden,
            })
        })
        .then((res) => res.json())
        .then((data) => {
            console.log(data);
            window.notie.alert({ type: 'success', text: 'Orden guardado correctamente',  });
        });
    },
})